module.exports = __webpack_public_path__ + "media/images/design/images/icons/instagram-color-dd11ddd0687dc1e8ae9836f6937ce4ee.png";